import { render, staticRenderFns } from "./CreateGroupUnit.vue?vue&type=template&id=930a889a&scoped=true"
import script from "./CreateGroupUnit.vue?vue&type=script&lang=ts"
export * from "./CreateGroupUnit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930a889a",
  null
  
)

export default component.exports